$(() => {
  const key = 'count-chars';
  const onInput = function () {
    const outputContainerId = `${this.name}_char_count`;
    const outputContainerSelector = `[id="${outputContainerId}"]`;
    if ($(outputContainerSelector).length === 0) {
      $('<div>')
        .addClass('form-text')
        .attr('id', outputContainerId)
        .insertAfter(this);
    }
    const outputContainer = $(outputContainerSelector);

    const rawCount = Array.from(
      (s =>
        $(this).data('count-chars-strip-tag') === true
          ? s.replace(/<[^>]+>/g, '')
          : s)(
        $(this)
          .val()
          .replace(/[\r\n/]/g, '')
      )
    ).reduce((acc, cur) => (acc += cur.charCodeAt() < 128 ? 1 : 2), 0);
    const count = Math.ceil(rawCount / 2);
    const max = Number($(this).data(key));
    outputContainer.text(`${count}/${max}`);
    if (count > max) {
      outputContainer.addClass('text-danger fw-bold');
    } else {
      outputContainer.removeClass('text-danger fw-bold');
    }
  };
  $(`[data-${key}]`)
    .each(function () {
      const _this = this;
      onInput.call(this);
      $($(this).data('count-chars-on-change-of')).on(
        'DOMSubtreeModified',
        function () {
          setTimeout(() => {
            onInput.call(_this);
          });
        }
      );
    })
    .on('input', onInput);
});
